import RowListCard from '@/app/pages/LoanDetail/components/RowListCard'

/**
 * @param {object} historyData - Raw or `screen`-wrapped history API payload
 * @param {{ loanId?: string|null, txnIndex?: string|null }} filters
 */
export const findRepaymentItem = (historyData, filters = {}) => {
  if (!historyData) {
    return null
  }

  const { loanId, txnIndex: txnIndexRaw } = filters

  const txnIndexParsed =
    txnIndexRaw != null && String(txnIndexRaw).trim() !== ''
      ? parseInt(String(txnIndexRaw), 10)
      : NaN

  if (
    loanId != null &&
    String(loanId).trim() !== '' &&
    !Number.isNaN(txnIndexParsed) &&
    txnIndexParsed >= 0
  ) {
    const lid = String(loanId)
    for (const section of historyData?.sections?.items || []) {
      if (section?.type !== 'list') {
        continue
      }
      const items = section?.components?.items || []
      const entry = items[txnIndexParsed]
      if (entry && String(entry?.meta?.loan_id) === lid) {
        return entry
      }
      break
    }
  }

  if (loanId != null && String(loanId).trim() !== '') {
    const lid = String(loanId)
    for (const section of historyData?.sections?.items || []) {
      if (section?.type !== 'list') {
        continue
      }
      const items = section?.components?.items || []
      const firstLoan = items.find(entry => String(entry?.meta?.loan_id) === lid)
      if (firstLoan) {
        return firstLoan
      }
    }
  }

  return null
}

export const getRepaymentDetailsSection = (section, index) => {
  switch (section?.type) {
    case 'row_list_card':
      return <RowListCard data={section} key={`${section?.type}-${index}`} />
    default:
      return null
  }
}
